
import { Vue, Options, Prop } from "vue-property-decorator";
@Options({
  name: "view-image",
})
export default class ViewImage extends Vue {
  @Prop({ default: "", type: String }) image: string;
}
